import ApuracaoBase from './apuracao-base';

import { formataPorcentagem } from './utils';
import getCustomLogger from './modules/logger';

const logger = getCustomLogger('Apuracao Panorama Base');

class ApuracaoPanoramaBase extends ApuracaoBase {
  constructor(options) {
    let key, url;

    if (options.container instanceof Node) {
      key = options.container.dataset.key;
      url = options.container.dataset['urlJsonApuracao']; // executivo.json
      options.container = [options.container];
    } else if (options.container instanceof NodeList) {
      url = `${options.jsonBaseURL}/${options.turno}/${options.jsonName}`; // panorama.json
      options.container = Array.prototype.slice.call(options.container);
    }

    const cidadeOptions = {
      key,
      url,
      compiledTemplates: {},
    };

    Object.assign(cidadeOptions, options);

    super(cidadeOptions);

    this.containerKeys = options.container.map((item) => {
      return item.dataset.key;
    });
  }

  successCallback(data) {
    if (data) {
      const dadosFilter = (item) => {
        return this.containerKeys.indexOf(item.abrangencia.key.toLowerCase()) !== -1;
      };

      let dados;

      if (!Array.isArray(data)) {
        dados = [data];
      } else {
        dados = data.filter(dadosFilter);
      }

      super.successCallback(dados);
    } else {
      logger.warn('Invalid response data from request url', this.options.url);
    }
  }

  atualizaCandidatos(dados, containerEl, templateName, templateOptions) {
    dados.candidatos = dados.candidatos.slice(0, 2).map((candidato) => {
      candidato.votos.porcentagem = formataPorcentagem(candidato.votos.porcentagem);
      return candidato;
    });

    this.renderTemplate(dados, containerEl, templateName, templateOptions);
  }

  atualizaAndamento(dados, containerEl, templateName, templateOptions) {
    const novosDados = {
      abrangencia: {
        andamento: 0,
      },
    };
    const porcentagemEl = containerEl.querySelector('.eui-percentage.eui-percentage--gray');

    novosDados.abrangencia.andamento = formataPorcentagem(dados.abrangencia.andamento);
    novosDados.abrangencia.aguardandoApuracao = dados.abrangencia.aguardandoApuracao;

    this.renderTemplate(novosDados, containerEl, templateName, templateOptions);

    if (porcentagemEl) {
      porcentagemEl.classList.add('eui-percentage--green');
      porcentagemEl.classList.remove('eui-percentage--gray');
    }
  }

  atualizarUpdateFrequency() {
    const dados = this._dados ? this._dados[0] : undefined;

    super.atualizarUpdateFrequency(dados);
  }

  atualizarTemplate() {
    for (let index = 0; this._dados.length > index; index++) {
      let dados = this._dados[index];
      let containerEl = this.containerEl[index];

      if (!containerEl) {
        continue;
      }

      for (var currentTemplateName in this.options.templates) {
        let currentTemplateOptions = this.options.templates[currentTemplateName];
        let matchedFunction = this[currentTemplateName];

        matchedFunction.call(this, dados, containerEl, currentTemplateName, currentTemplateOptions);
      }
    }
  }

  estaMatDefinida() {
    if (!this._dados || !Array.isArray(this._dados)) {
      return false;
    }

    const finalizado = this._dados.every(function (item) {
      return item.abrangencia.matDefinido;
    });
    return finalizado;
  }

  renderTemplate(data, containerEl, currentTemplateName, templateOptions) {
    const currentContext = {
      options: this.options,
      containerEl: containerEl,
    };

    super.renderTemplate.apply(currentContext, [data, currentTemplateName, templateOptions]);
  }

  estaFinalizada() {
    if (!this._dados || !Array.isArray(this._dados)) {
      return false;
    }

    const finalizado = this._dados.every(function (item) {
      return item.abrangencia.totalizacaoFinal;
    });

    return finalizado;
  }

  animarBarrinhas() {
    for (let i = 0; this.containerEl.length > i; i++) {
      let currentContext = {
        containerEl: this.containerEl[i],
        _dados: this._dados[i],
        getAndamento: this.getAndamento,
      };

      super.animarBarrinhas.apply(currentContext, []);
    }

    return this;
  }

  isInFocus() {
    for (let index = 0; index < this.containerEl.length; index++) {
      let context = {
        containerEl: this.containerEl[index],
      };

      if (super.isInFocus.apply(context, [])) {
        return true;
      }
    }
    return false;
  }

  ultimaAtualizacao() {
    let atualizadoEl = document.querySelector('.js-atualizacao-panorama');
    let ultimaAtualizacaoEl = document.querySelector('.js-ultima-atualizacao-panorama');
    if (atualizadoEl && ultimaAtualizacaoEl) {
      if (this.estaFinalizada()) {
        this.showAtualizacaoTotalizado(atualizadoEl, ultimaAtualizacaoEl);
      } else if (this.estaMatDefinida()) {
        this.showAtualizacaoMatDefinido(atualizadoEl, ultimaAtualizacaoEl);
      } else {
        this.showAtualizacao(atualizadoEl, ultimaAtualizacaoEl);
      }
    }
  }

  showAtualizacaoTotalizado(atualizadoEl, ultimaAtualizacaoEl) {
    this.elements.atualizacaoContainer.style.display = 'none';
    ultimaAtualizacaoEl.style.display = 'block';

    atualizadoEl.style.display = 'none';
  }

  showAtualizacaoMatDefinido(atualizadoEl, ultimaAtualizacaoEl) {
    this.elements.atualizacaoContainer.classList.add('eui-timer-piano--green');
    this.elements.atualizacaoContainer.style.display = 'flex';

    atualizadoEl.style.display = 'block';
    ultimaAtualizacaoEl.style.display = 'none';
  }

  showAtualizacao(atualizadoEl, ultimaAtualizacaoEl) {
    this.elements.atualizacaoContainer.classList.remove('eui-timer-piano--green');
    this.elements.atualizacaoContainer.style.display = 'flex';

    ultimaAtualizacaoEl.style.display = 'none';
    atualizadoEl.style.display = 'block';
  }
}

export default ApuracaoPanoramaBase;
